import { render } from "./TheCart.vue?vue&type=template&id=970dba54&scoped=true"
import script from "./TheCart.vue?vue&type=script&lang=js"
export * from "./TheCart.vue?vue&type=script&lang=js"

import "./TheCart.vue?vue&type=style&index=0&id=970dba54&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-970dba54"]])

export default __exports__